import {
  LOGISTICS_ORDER_STATUS_LABELS,
  type LogisticsOrderStatus,
} from '@/modules/logistics/types';

const STATUS_CLASS: Record<LogisticsOrderStatus, string> = {
  pending: 'logistics-badge--pending',
  scheduled: 'logistics-badge--scheduled',
  in_transit: 'logistics-badge--in-transit',
  delivered: 'logistics-badge--delivered',
  returned: 'logistics-badge--returned',
  cancelled: 'logistics-badge--cancelled',
};

type LogisticsStatusBadgeProps = {
  status: LogisticsOrderStatus;
};

export function LogisticsStatusBadge({ status }: LogisticsStatusBadgeProps) {
  return (
    <span className={`logistics-badge ${STATUS_CLASS[status]}`}>
      {LOGISTICS_ORDER_STATUS_LABELS[status]}
    </span>
  );
}
